<template>
	<div>
		<hr v-if="answerInputidx > 0"/>
		<div class="item-row">
			<div class="item-cell" v-html="infoHtml"></div>
		</div>
		<div class="item-row example-group" style="margin-top:4px">
			<div class="item-cell left-example-group">
				<div class="item-row" v-for="(example, i) in leftExampleList" :key="'ex' + i" style="margin-bottom:4px;">
					<div class="item-cell text-align-right">
						{{example}}
					</div>
					<button class="item-cell item-cell button button-outline" :disabled="mode != 'ANSWER'" v-on:click="leftExampleClick" v-bind:class="[leftStyleClass(i)]" style="width:40px;">
						<span class="badge color-black" v-if="isDisplayLeftAnswer(i)">{{leftAnswer(i)}}</span> 
						<span v-else>{{i+1}}</span>
					</button>
				</div>
			</div>
			<div class="item-cell right-example-group">
				<div class="item-row" v-for="(example, i) in rightExampleList" :key="'ex' + i" style="margin-bottom:4px;">
					<button class="item-cell item-cell button button-outline" :disabled="mode != 'ANSWER'" :data-match="match(i)" v-on:click="rightExampleClick" v-bind:class="[rightStyleClass(i)]" style="width:40px;">
						<span class="badge color-black" v-if="isDisplayRightAnswer(i)">{{rightAnswer(i)}}</span> 
						<span v-else>{{i+1}}</span>
					</button>
					<div class="item-cell">
						{{example}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MODULE from '../../js/common/module';
import store from '../../js/store';
import MathLive from 'mathlive';

export default {
	props: {
		examNo: { default: 0 },
		subExamIdx: { default: 0 },
		answerInputidx: { default: 0 },
	},
	data() {
		return {
			infoHtml: "",
		}
	},
	computed: {
		mode() {
			var mode = this.getCommonObj().mode;
			return mode;
		},
		info() {
			return this.getAnswerInput().info;
		},
		answer() {
			return this.getAnswerInput().answer;
		},
		inputAnswer: {
			get() {
				return this.getAnswerInput().inputAnswer;
			},
			set(newValue) {
				var answerInput = this.getAnswerInput();
				answerInput.inputAnswer = newValue;
			}
		},
		leftExampleList() {
			return this.getAnswerInput().leftExampleList;
		},
		rightExampleList() {
			return this.getAnswerInput().rightExampleList;
		},
	},
	created() {
		this.colors = [
			"button-fill color-red",
			"button-fill color-orange",
			"button-fill color-yellow",
			"button-fill color-green",
			"button-fill color-blue",
			"button-fill color-teal",
			"button-fill color-purple"
		]; 
	},
	mounted() {
		this.renderInfo();
	},
	methods: {
		getCommonObj() {
			return store.getters.commonObj;
		},
		getAnswerInput() {
			var answers = this.getCommonObj().answers;

			var examIndex = this.examNo - 1;
			var exam = answers[examIndex];
			var subExam = exam.subExamList[this.subExamIdx];
			var answerInput = subExam.answerInputList[this.answerInputidx];

			return answerInput;
		},
		match(index) {
			var inputAnswer = this.getAnswerInput().inputAnswer;
			var arr = MODULE.Util.splitGroupValue(inputAnswer);
			var value = arr[index];
			var match = value.charAt(1);

			return match;
		},
		renderInfo() {
			let html = this.info;
			if (MODULE.Util.isEmpty(html)) {
				this.infoHtml = "짝짓기형 답안"
			} else {
				this.infoHtml = MathLive.latexToMarkup(this.info, "displaystyle");
			}
		},
		parseField(LR, AIA, index) {
			let _answer = "";
			if (AIA == 'ANSWER') {
				_answer = this.answer;
			} else if (AIA == "INPUT_ANSWER") {
				_answer = this.inputAnswer;
			}

			if (MODULE.Util.isEmpty(_answer)) {
				return "-";
			}

			const arr = MODULE.Util.splitGroupValue(_answer);
			const value = arr[index];
			
			let val = "";
			if (LR == "LEFT") {
				val = value.charAt(0);
			} else if (LR == "RIGHT") {
				val = value.charAt(1);
			}

			if (MODULE.Util.isNotEmpty(val) && val != '-') {
				return val;
			}

			return "-";
		},
		leftStyleClass(index) {
			const leftInputAnswer = this.parseField("LEFT", "INPUT_ANSWER", index);

			if (leftInputAnswer == "-") {
				return "button-outline";
			}

			const colorIndex = leftInputAnswer - 1;
			return this.colors[colorIndex];
		},
		rightStyleClass(index) {
			const rightInputAnswer = this.parseField("RIGHT", "INPUT_ANSWER", index);

			if (rightInputAnswer == "-") {
				return "button-outline";
			}

			const colorIndex = rightInputAnswer - 1;
			return this.colors[colorIndex];
		},
		isDisplayLeftAnswer(index) {
			if (this.mode != "SCORE") {
				return false;
			}

			const leftAnswer = this.parseField("LEFT", "ANSWER", index);
			if (leftAnswer == "-") {
				return false;
			}

			return true;
		},
		isDisplayRightAnswer(index) {
			if (this.mode != "SCORE") {
				return false;
			}

			const rightAnswer = this.parseField("RIGHT", "ANSWER", index);
			if (rightAnswer == "-") {
				return false;
			}

			return true;
		},
		leftAnswer(index) {
			const leftAnswer = this.parseField("LEFT", "ANSWER", index);
			return leftAnswer;
		},
		rightAnswer(index) {
			const rightAnswer = this.parseField("RIGHT", "ANSWER", index);
			return rightAnswer;
		},
		leftExampleClick(e) {
			if (this.mode != "ANSWER") {
				return;
			}

			const thisButton = $(e.currentTarget);
			const exampleGroup = thisButton.closest(".example-group");
			const leftButtons = exampleGroup.find(".left-example-group button");
			const rightButtons = exampleGroup.find(".right-example-group button");
			
			const thisButtonIndex = leftButtons.index(thisButton);

			exampleGroup.data("match-ready", String(thisButtonIndex + 1));

			if (thisButton.hasClass("button-outline")) {
				thisButton.removeClass("button-outline");
				thisButton.addClass("button-fill");
			}

			var values = [];
			for (var i=0; i<leftButtons.length; i++) {
				var value = "--";
				var left = "-";
				var right = "-";

				var leftButton = $(leftButtons[i]);
				if (leftButton.hasClass("button-fill")) {
					left = String(i + 1);
				}

				var rightButton = $(rightButtons[i]);
				if (rightButton.hasClass("button-fill")) {
					var match = rightButton.data("match");
					right = match;
				}

				value = left + right;
				values.push(value);
			}

			var inputAnswer = MODULE.Util.mergeGroupValue(values);
			this.inputAnswer = inputAnswer;
		},
		rightExampleClick(e) {
			if (this.mode != "ANSWER") {
				return;
			}

			const thisButton = $(e.currentTarget);
			const exampleGroup = thisButton.closest(".example-group");
			const leftButtons = exampleGroup.find(".left-example-group button");
			const rightButtons = exampleGroup.find(".right-example-group button");
			
			const thisButtonIndex = rightButtons.index(thisButton);

			var matchReady = exampleGroup.data("match-ready");
			if (MODULE.Util.isEmpty(matchReady)) {
				MODULE.DialogBox.infoToast("왼쪽 보기 부터 선택하세요.");
				return;
			}
			exampleGroup.data("match-ready", "");


			if (thisButton.hasClass("button-outline")) {
				thisButton.removeClass("button-outline");
				thisButton.addClass("button-fill");
			}

			thisButton.data("match", matchReady);


			var values = [];
			for (var i=0; i<rightButtons.length; i++) {
				var value = "--";
				var left = "-";
				var right = "-";

				var leftButton = $(leftButtons[i]);
				if (leftButton.hasClass("button-fill")) {
					left = String(i + 1);
				}

				var rightButton = $(rightButtons[i]);
				if (i == thisButtonIndex) {
					var match = rightButton.data("match");
					right = match;
				} else {
					var match = rightButton.data("match");
					if (MODULE.Util.isNotEmpty(match)) {
						if (match != matchReady) {
							right = match;
						} else {
							rightButton.data("match", "");
						}
					}
				}

				value = left + right;
				values.push(value);
			}

			var inputAnswer = MODULE.Util.mergeGroupValue(values);
			this.inputAnswer = inputAnswer;
		}
	}
}

</script>